import {api} from '../../api';
import {createMutation} from '../../lib';

const {deleteFiltersSets} = api.filtersSets;

export const useDeleteFiltersSets = createMutation((params: Parameters<typeof deleteFiltersSets>) =>
  deleteFiltersSets(...params),
);
